/// <amd-module name="Artifacts/Maven/components/Logo" />
import * as MavenRes from "Artifacts/Maven/Resources";
import { ILogoProps } from "Artifacts/Package/types/ILogoProps";
import * as React from "react";
import { Components, useComponentContext } from "VSS/Platform/Layout";
import { getAssetLocation } from "VSS/Platform/Location";
import { Image } from "VSSUI/Image";

export const logoContributionId = "ms.azure-artifacts.protocol-maven.logo";

const Logo: React.FC<ILogoProps> = ({ className }) => {
  const { pageContext } = useComponentContext();

  return (
    <Image
      className={className}
      alt={MavenRes.Logo_Maven}
      src={getAssetLocation(pageContext, "ms.azure-artifacts/protocol-maven/img/maven.svg")}
    />
  );
};

Components.add(logoContributionId, Logo);

export { Logo };
